import { Button, Dialog } from '../../../components/ui';
import { useLoi } from '../../../hooks/useLoi';
import { useT } from '../../../i18n';
import { soVN } from '../../../lib/dinh-dang';
import { LoiTrongHop } from '../../tenant/components/phan-form';
import type { Role } from '../types';

/**
 * Hộp xác nhận xoá vai trò (`DELETE /api/v1/roles/{id}`).
 *
 * Server gỡ vai trò khỏi mọi người đang có, nên thân hộp nói **bao nhiêu
 * người** mất quyền (`user_count`) và rằng không hoàn tác được. Lỗi hiện trong
 * hộp, hộp không đóng.
 */
export function HopXoaVaiTro({
  open,
  vaiTro,
  dangChay,
  loi,
  onClose,
  onXacNhan,
}: {
  open: boolean;
  /** Giữ nguyên khi hộp đang đóng, để tiêu đề không nháy trống lúc mờ dần. */
  vaiTro: Role | null;
  dangChay: boolean;
  loi: unknown;
  onClose: () => void;
  onXacNhan: (vaiTro: Role) => void;
}) {
  const { t, locale } = useT();
  const dichLoi = useLoi();
  const soNguoi = vaiTro?.user_count ?? 0;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={t('vaiTroLop2.xnXoaTieuDe', { ten: vaiTro?.name ?? '' })}
      width={480}
      destroyOnHidden
      footer={
        <div className="flex flex-wrap justify-end gap-3">
          <Button variant="outline" size="md" onClick={onClose}>
            {t('chung.huy')}
          </Button>
          <Button
            variant="destructive"
            size="md"
            loading={dangChay}
            onClick={() => vaiTro && onXacNhan(vaiTro)}
          >
            {t('vaiTroLop2.xoaVaiTro')}
          </Button>
        </div>
      }
    >
      <div className="space-y-3 pt-2">
        <p className="text-sm leading-relaxed text-content-secondary">
          {soNguoi > 0
            ? t('vaiTroLop2.xnXoaThanCoNguoi', { so: soVN(soNguoi, locale) })
            : t('vaiTroLop2.xnXoaThanChuaAi')}
        </p>
        {Boolean(loi) && <LoiTrongHop>{dichLoi(loi)}</LoiTrongHop>}
      </div>
    </Dialog>
  );
}
